<template>
    <modal name="create_user" height="auto" scrollable adaptive>
        <app-card :title="$t('Create user')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-input id="name" v-model="form.name" name="name" rules="required">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-input>
                    <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                        <template #label>
                            {{ $t('Email') }}*
                        </template>
                    </app-input>
                    <app-select id="roles"
                                v-model="form.roles"
                                :options="roles.map(c => c.id)"
                                name="roles"
                                rules="required"
                                searchable
                                multiple
                                not-empty
                                closeOnSelect
                                :custom-label="id => roles.some(c => c.id === id) ? roles.find(c => c.id === id).name : null">
                        <template #label>
                            {{ $t('Roles') }}*
                        </template>
                    </app-select>
                    <app-input id="password" v-model="form.password" name="password" rules="required|password:@password_confirmation" type="password">
                        <template #label>
                            {{ $t('Password') }}*
                        </template>
                    </app-input>
                    <app-input id="password_confirmation" v-model="form.password_confirmation" rules="required" name="password_confirmation" type="password">
                        <template #label>
                            {{ $t('Confirm password') }}*
                        </template>
                    </app-input>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import UserService from '@services/user.service';
import RoleService from '@services/role.service';

export default {
    data() {
        return {
            roles: [],
            form: {
                name: '',
                email: '',
                password: '',
                roles: []
            },
            loading: false
        };
    },
    methods: {
        getRoles() {
            RoleService.roles().then(res => this.roles = res);
        },
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    UserService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setUser', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_user');
        }
    },
    created() {
        this.getRoles();
    }
};
</script>
